var _circle, _g, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUserSearh = function SvgUserSearh(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#EDF5FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18.0257 15.5237C17.2079 15.2277 15.8453 14.875 14 14.875C12.1547 14.875 10.7921 15.2277 9.97434 15.5237C9.29819 15.7681 8.84375 16.4171 8.84375 17.1393V18.6562C8.84375 18.846 8.99775 19 9.1875 19H18.8125C19.0022 19 19.1562 18.846 19.1562 18.6562V17.1393C19.1562 16.4171 18.7018 15.7681 18.0257 15.5237Z",
    fill: "#4B97E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 14.1875C15.5163 14.1875 16.75 12.9538 16.75 11.4375V10.75C16.75 9.23372 15.5163 8 14 8C12.4837 8 11.25 9.23372 11.25 10.75V11.4375C11.25 12.9538 12.4837 14.1875 14 14.1875Z",
    fill: "#4B97E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(8.5 8)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUserSearh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user_searh.c4e19b0e.svg";
export { ForwardRef as ReactComponent };